import { Link } from "react-router-dom";
import { ArrowBigRight } from "lucide-react";
import Button from "@/common/components/Button";
import { TrackerIntegrationData } from "../../types/trackerIntegration.type";

export class TrackerIntegrationsTransformer {
  static tableTransformer(companyId: string) {
    return (trackerIntegrations: TrackerIntegrationData[]) => {
      return trackerIntegrations.map((trackerIntegration) => ({
        ...trackerIntegration,
        displayName: trackerIntegration?.option?.display_name,
        active: trackerIntegration.active ? 'Sim' : 'Não',
        actions: <Link to={`/companies/${companyId}/tracker-integrations/${trackerIntegration.id}`} className="cursor-pointer">
          <Button name="access_tracker_integrations_list" className="bg-transparent hover:bg-transparent p-0" operationKlassToCheckPermission='Admin::Client::TrackerIntegrations::Show'>
            <ArrowBigRight />
          </Button>
        </Link>
      }));
    };
  }

  static errorsTransformer() {
    return (errors: Record<string, string[]>) => {
      return Object.entries(errors).map(([key, value]) => {
        if (key === "company_id") {
          key = "option_id";
        }

        return {
          [key]: value.join(', ')
        }
      });
    };
  }
}
